export const sustainability = {
  // -----
  section01: {
    title: "Sự bền vững",
    content: [
      "Với vai trò là một công ty, chúng tôi đặc biệt coi trọng tính bền vững như một nguyên tắc kinh doanh cốt lõi trong mọi việc chúng tôi làm.",
      "Cam kết về nguyên tắc bền vững của Rèm cửa Huy Hoàng được thể hiện trong hoạt động hàng ngày của chúng tôi với việc giảm lượng khí thải carbon và quảng bá các sản phẩm mang tính bền vững cho ngành xây dựng. Dưới đây là một số cách mà Rèm cửa Huy Hoàng góp phần làm cho thế giới này trở nên tốt đẹp hơn.",
      "Rèm cửa Huy Hoàng không ngừng nỗ lực để hoạt động bền vững trên mọi phương diện hoạt động kinh doanh. Để biết thêm thông tin chi tiết, vui lòng tải xuống bản sao Chính sách Môi trường của chúng tôi bên dưới.",
    ],
  },
};
